import { createAction } from '@reduxjs/toolkit';

export const pricingUpdateId = createAction('pricing/updateId');
export const pricingUpdateUID = createAction('pricing/updateUid');
export const pricingUpdateSID = createAction('pricing/updateSid');
export const pricingUpdateIsAdded = createAction('pricing/updateIsAdded');
export const pricingUpdateIsActive = createAction('pricing/updateIsActive');

export const pricingStore = createAction('pricing/store');
export const pricingClear = createAction('pricing/clear');

export const pricingUpdateRequest = createAction('pricing/updateRequest');
export const pricingUpdateError = createAction('pricing/updateError');
export const pricingUpdateStore = createAction('pricing/updateStore');

export const pricingUpdateHeadingTitle = createAction('pricing/updateHeadingTitle');
export const pricingUpdateHeadingDescription = createAction('pricing/updateHeadingDescription');
export const pricingUpdateHeadingTextAlign = createAction('pricing/updateHeadingTextAlign');
export const pricingUpdateHeadingImage = createAction('pricing/updateHeadingImage');
export const pricingUpdateHeadingDivider = createAction('pricing/updateHeadingDivider');

export const pricingUpdateSectionIsBackground = createAction('pricing/updateSectionIsBackground');
export const pricingUpdateSectionTextColor = createAction('pricing/updateSectionTextColor');
export const pricingUpdateSectionBackgroundColor = createAction('pricing/updateSectionBackgroundColor');
export const pricingUpdateSectionOpacity = createAction('pricing/updateSectionOpacity');
export const pricingUpdateSectionIsFullWidth = createAction('pricing/updateSectionIsFullWidth');
export const pricingUpdateSectionShadow = createAction('pricing/updateSectionShadow');
export const pricingUpdateSectionShadowColor = createAction('pricing/updateSectionShadowColor');
export const pricingUpdateSectionPadding = createAction('pricing/updateSectionPadding');
export const pricingUpdateSectionMargin = createAction('pricing/updateSectionMargin');
export const pricingUpdateSectionBackgroundType = createAction('pricing/updateSectionBackgroundType');
export const pricingUpdateSectionBackgroundImage = createAction('pricing/updateSectionBackgroundImage');
export const pricingUpdateSectionGradientColor1 = createAction('pricing/updateSectionGradientColor1');
export const pricingUpdateSectionGradientColor2 = createAction('pricing/updateSectionGradientColor2');
export const pricingUpdateSectionGradientDirection = createAction('pricing/updateSectionGradientDirection');
export const pricingUpdateSectionGradientOffset = createAction('pricing/updateSectionGradientOffset');
export const pricingUpdateSectionBorder = createAction('pricing/updateSectionBorder');
export const pricingUpdateSectionBorderColor = createAction('pricing/updateSectionBorderColor');
export const pricingUpdateSectionShadowBorderColor = createAction('pricing/updateSectionShadowBorderColor');
export const pricingUpdateSectionShape = createAction('pricing/updateSectionShape');

export const pricingUpdateItemShadow = createAction('pricing/updateItemShadow');
export const pricingUpdateItemShadowColor = createAction('pricing/updateItemShadowColor');
export const pricingUpdateItemBorder = createAction('pricing/updateItemBorder');
export const pricingUpdateItemBorderColor = createAction('pricing/updateItemBorderColor');
export const pricingUpdateItemShape = createAction('pricing/updateItemShape');
export const pricingUpdateItemTextColor = createAction('pricing/updateItemTextColor');
export const pricingUpdateItemBackgroundColor = createAction('pricing/updateItemBackgroundColor');

export const pricingUpdateItems = createAction('pricing/updateItems');
export const pricingUpdateView = createAction('pricing/updateView');

export const pricingUpdateGroups = createAction('pricing/updateGroups');
